// extracted by mini-css-extract-plugin
module.exports = {"main":"tabs_main__SjHBS","user":"tabs_user__gaf8V","atv":"tabs_atv__OOlMR"};